import ListItem from '../utils/ListItem';

function BasesListItem(props) {
  return (
    <ListItem
      to={{ pathname: props.link, from: window.location.pathname + window.location.search }}
      primary={props.name}
      secondary={props.location}
    />
  );
}

export default BasesListItem;
